function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.867 16H32.134L33.834 27H31.034C30.524 27 30.066 27.25 29.784 27.66L28.674 29.32V29.31C28.394 29.72 27.924 29.97 27.424 29.97H22.564C22.054 29.97 21.594 29.72 21.314 29.3L20.204 27.63C19.924 27.21 19.454 26.96 18.954 26.96H16.154L17.854 15.96L17.867 16ZM35.987 27.84L34.047 15.29C33.947 14.54 33.307 13.98 32.557 13.98H17.42C16.67 13.98 16.03 14.54 15.936 15.26L13.99 27.82H13.98C13.97 27.87 13.96 27.92 13.96 27.97V34.47C13.96 35.29 14.633 35.97 15.46 35.97H34.46C35.28 35.97 35.96 35.29 35.96 34.47V27.97C35.96 27.91 35.95 27.86 35.94 27.81L35.987 27.84Z"
});

function SvgIc5D5F9Be4Fc0611Eb9A030242Ac130003(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc5D5F9Be4Fc0611Eb9A030242Ac130003);
export default ForwardRef;